import type { POISubType } from '@alltrails/types/AlgoliaResults';

// Follows getPOIIcon, so subtypes sharing a pin share a checkbox. Labels are hardcoded English until ADV-335
export const poiGroups = [
  { id: 'peak', label: 'Peak', subtypes: ['peak'] },
  { id: 'waterfall', label: 'Waterfall', subtypes: ['waterfall'] },
  { id: 'garden', label: 'Garden', subtypes: ['garden'] },
  { id: 'birdHide', label: 'Bird hide', subtypes: ['bird_hide'] },
  { id: 'wildlifeHide', label: 'Wildlife hide', subtypes: ['wildlife_hide'] },
  { id: 'beach', label: 'Beach', subtypes: ['bay', 'beach'] },
  { id: 'lake', label: 'Lake', subtypes: ['lake'] },
  { id: 'hotSpring', label: 'Hot spring', subtypes: ['hot_spring'] },
  { id: 'viewpoint', label: 'Viewpoint', subtypes: ['viewpoint'] },
  { id: 'river', label: 'River', subtypes: ['river'] },
  { id: 'cave', label: 'Cave', subtypes: ['cave'] },
  { id: 'historicSite', label: 'Historic site', subtypes: ['archaeological_site', 'historic_site', 'ruins', 'monument'] },
  { id: 'campsite', label: 'Campsite', subtypes: ['campsite'] },
  { id: 'other', label: 'Other', subtypes: [] }
] as const satisfies readonly { id: string; label: string; subtypes: readonly POISubType[] }[];

/** Persisted to localStorage, so renaming an id drops that exclusion for every user. */
export type PoiGroupId = (typeof poiGroups)[number]['id'];

const subtypeToGroupId = new Map<POISubType, PoiGroupId>(
  poiGroups.flatMap(group => group.subtypes.map((subtype): [POISubType, PoiGroupId] => [subtype, group.id]))
);

export const getPoiGroupId = (subtype: POISubType): PoiGroupId => subtypeToGroupId.get(subtype) ?? 'other';

export const isPoiGroupId = (value: unknown): value is PoiGroupId => poiGroups.some(group => group.id === value);
